import { Text } from '@approvalmax/ui/src/components';
import { CompanyRequestListFilter } from 'pages/requestList/config';
import { FC, memo, useCallback } from 'react';
import { amplitudeService } from 'services/amplitude';
import { getPath, Path } from 'urlBuilder';

import { CollapseSection } from '../CollapseSection/CollapseSection';
import { messages } from './RequestApproval.messages';
import { RequestApprovalProps } from './RequestApproval.types';

export const RequestApproval: FC<RequestApprovalProps> = memo((props) => {
    const { number, collapsed, complete, companyId, profileId } = props;

    const handleButtonClick = useCallback(() => {
        amplitudeService.sendData('getting started: clicked on start approving', {
            user_id: profileId,
            org_id: companyId,
        });
    }, [companyId, profileId]);

    return (
        <CollapseSection
            collapsed={collapsed}
            complete={complete}
            number={number}
            title={messages.title}
            buttonText={messages.buttonText}
            buttonLink={getPath(
                Path.requestCompanyList,
                companyId,
                CompanyRequestListFilter.CompanyMyDecisionRequired,
                {
                    gettingStarted: true,
                }
            )}
            onButtonClick={handleButtonClick}
        >
            <Text font='body'>{messages.description}</Text>
        </CollapseSection>
    );
});

RequestApproval.displayName = 'RequestApproval';
